'use strict';

var $modal = document.getElementById('genericModal');
var $modalClose = $modal.querySelector('[data-dismiss="modal"]');
var $modalBackdrop = document.querySelector('.modal-backdrop');
let previousFocused;
const ESC_KEY = 27;

var Modal = {
  open: function open(body) {
    if (!$modal) return;
    Modal.windowTopClass && $modal.classList.remove(Modal.windowTopClass);

    if (body.windowTopClass) {
      $modal.classList.add(body.windowTopClass);
      Modal.windowTopClass = body.windowTopClass;
    }

    if (body.onClose) {
      Modal.onClose = body.onClose;
    }

    previousFocused = body.previousFocused;
    $modal.querySelector('.modal-title').innerHTML = body.title || '';
    $modal.querySelector('.modal-body').innerHTML = body.body || '';
    $modal.classList.add('is-visible');

    document.body.classList.add('modal-open');

    Modal.accessibility('openModal');

    setTimeout(function () {
      if (body.onOpen && typeof body.onOpen === 'function') {
        body.onOpen.call(null, $modal);
      }

      Modal.showBackdrop();
      $modal.classList.add('in');
    }, 100);
  },

  close: function close() {
    if (!$modal) return;
    $modal.classList.remove('in');
    setTimeout(function () {
      $modal.querySelector('.modal-title').innerHTML = '';
      $modal.querySelector('.modal-body').innerHTML = '';
      $modal.classList.remove('is-visible');

      document.body.classList.remove('modal-open');

      Modal.accessibility('closeModal');

      typeof Modal.onClose === 'function' && Modal.onClose.call();
      Modal.onClose = null;
      Modal.hideBackdrop();
    }, 500);
  },

  showBackdrop: function showBackdrop() {
    if (!$modalBackdrop) return;
    $modalBackdrop.classList.remove('is-hide', 'out');
    $modalBackdrop.classList.add('in');
  },

  hideBackdrop: function hideBackdrop() {
    if (!$modalBackdrop) return;
    $modalBackdrop.classList.remove('in');
    $modalBackdrop.classList.add('out');
    setTimeout(function () {
      $modalBackdrop.classList.add('is-hide');
    }, 500);
  },

  accessibility: function accessibility(action) {
    document.addEventListener('keyup', (event) => {
      if (event.keyCode === ESC_KEY) Modal.close();
    });

    if (action === 'openModal') {
      $modal.setAttribute('aria-hidden', false);

      $modal.querySelector('.close-btn').focus();
    } else {
      $modal.setAttribute('aria-hidden', true);

      $modal.querySelector('.modal-title').blur();

      previousFocused?.setAttribute('aria-hidden', true);
      previousFocused?.focus();
    }
  }
};

var _close = function (event) {
  var target = event.target || {};
  if (target === this || (this.dataset || {}).dismiss === 'modal') {
    Modal.close();
  }
};

$modal && $modal.addEventListener('click', _close, false);
$modalClose && $modalClose.addEventListener('click', _close, false);

module.exports = Modal;
